<template lang="pug">
  .homepage-navigation
    .homepage-navigation__list
      swiper.homepage-navgiation__swiper(ref="homepageNavigationSwiper" :options="swiperOptions" data-slideout-ignore)
        swiper-slide(v-for="(chunk, key) in slideChunks" :key="key")
          router-link.homepage-navigation__list-item(v-for="category in chunk" :key="category.id" :to="'/shop/' + category.slug")
            .homepage-navigation__list-item-container
              .homepage-navigation__list-item-icon-container
                img.homepage-navigation__list-item-icon(:src="category.featured_image")
              .homepage-navigation__list-item-name
                span {{ category.name }}
      .homepage-navgiation__swiper-button.homepage-navgiation__swiper-button--next(slot="button-next")
        font-awesome-icon(:icon=['far', 'chevron-right'])
      .homepage-navgiation__swiper-button.homepage-navgiation__swiper-button--prev(slot="button-prev")
        font-awesome-icon(:icon=['far', 'chevron-left'])
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import MobileDetect from 'mobile-detect';
import { RepositoryFactory } from '../../repositoryFactory';

import 'swiper/css/swiper.css';

const ProductCategoryRepository = RepositoryFactory.get('productCategory');

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      categories: [],
      swiperOptions: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.homepage-navgiation__swiper-button--next',
          prevEl: '.homepage-navgiation__swiper-button--prev',
        },
      },
    };
  },
  computed: {
    slideChunks() {
      const md = new MobileDetect(window.navigator.userAgent);
      let chunkSize = 7;
      console.log(md.mobile(), md.tablet());
      if (md.phone() && !md.is('iPad')) chunkSize = 8;
      if (md.is('iPad')) chunkSize = 6;
      return _.chunk(Object.values(this.categories), chunkSize);
    },
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    async getCategories() {
      try {
        const { data } = await ProductCategoryRepository.get({ show_on_homepage: true }).then((resp) => resp.data);
        this.categories = data;
      } catch (e) {
        this.categories = [];
      }
    },
  },
};
</script>
